import type { AllocNode } from "./buildAllocationTree";

export function AllocationTree({
  root, selectedKey, onSelect,
}: {
  root: AllocNode; selectedKey: string | null; onSelect: (key: string) => void;
}) {
  return (
    <div style={{ minWidth: 240, fontSize: "0.85rem" }}>
      <TreeNode node={root} depth={0} selectedKey={selectedKey} onSelect={onSelect} />
    </div>
  );
}

function TreeNode({
  node, depth, selectedKey, onSelect,
}: {
  node: AllocNode; depth: number; selectedKey: string | null; onSelect: (k: string) => void;
}) {
  const selected = node.key === selectedKey;
  return (
    <div>
      <button
        type="button"
        onClick={() => onSelect(node.key)}
        style={{
          display: "block", width: "100%", textAlign: "left", cursor: "pointer",
          padding: "3px 6px", paddingLeft: 6 + depth * 14, border: "none",
          background: selected ? "var(--surface-2)" : "transparent",
          color: "var(--text)", borderRadius: 4,
        }}
      >
        {node.label}
        {node.source === "legacy" && <span style={{ marginLeft: 6, fontSize: "0.7rem", opacity: 0.7 }}>legacy</span>}
        <span style={{ float: "right", color: "var(--text-dim)" }}>{node.cidr ?? (node.kind === "site" || node.kind === "account" ? "not allocated" : "")}</span>
      </button>
      {node.children.map((c) => (
        <TreeNode key={c.key} node={c} depth={depth + 1} selectedKey={selectedKey} onSelect={onSelect} />
      ))}
    </div>
  );
}
